module.exports = __webpack_public_path__ + "static/assets/b893cfaa79f7003f7bfa6aa5794990a0.svg";